import { axiosFactory, errorHandler } from "@/configs/axios";

const companyprofile = {
  api: (payload) => {
    return axiosFactory()
      .auth.get("/crm/companies/" + payload + "/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export { companyprofile };
